import Category from '@shared/classes/category';
import Content from '../../types/enums/content';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { store } from '../../store/store';
import {
  RailDisplayMode,
  RailOrderSort,
  RailOrderType,
  RailType,
} from '../../types/enums/rail';

function generateChannelsRails() {
  const { categories, channels } = store.getState();
  const filtersBase = {
    section: {
      presentationType: RailDisplayMode.FILTER,
      name: 'filterRail',
    },
  };
  const channelsBase = {
    section: {
      presentationType: RailDisplayMode.SQUARE,
      name: 'channelSquareRail',
    },
  };
  const nowOnTvBase = {
    section: {
      title: TranslationManager.get('COMPONENTS.RAILS.TITLE.NOW_ON_TV'),
      presentationType: RailDisplayMode.PHOTO,
      name: 'channelPhotoRail',
    },
  };

  const categoriesData = categories.data?.reduce(
    (results: Category[], category: Category) => {
      const hasData = channels.favouriteChannels?.find(
        (channel) =>
          channel.category === category.id || channel.category === category.name
      );
      if (hasData) {
        results.push(category);
      }
      return results;
    },
    []
  );

  categoriesData?.length &&
    categoriesData.unshift(
      new Category({
        id: '',
        created: '',
        name: '',
        order: 0,
        orderField: '',
        presentationType: '',
        title: TranslationManager.get('COMPONENTS.FILTER.ALL'),
        updated: '',
      })
    );

  const eventsData = channels.favouriteChannels
    ?.map(
      (item) => item?.getCurrentEvent() || item?.getMockedEvent() || undefined
    )
    ?.filter((item) => {
      if (item && item.channel?.type !== (Content.AVOD || Content.SVOD)) {
        return true;
      }
      return false;
    });

  const filterRail = Rail.constructorWithData(
    filtersBase,
    categoriesData || [],
    RailType.FILTER
  );
  filterRail.sortRail(RailOrderType.RATING, RailOrderSort.ASCENDING);

  const channelsRail = Rail.constructorWithData(
    channelsBase,
    eventsData || [],
    RailType.CHANNEL
  );
  const nowOnTvRail = Rail.constructorWithData(
    nowOnTvBase,
    eventsData || [],
    RailType.EPG
  );
  return [filterRail, channelsRail, nowOnTvRail];
}

export default generateChannelsRails;
